var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMerge = function SvgMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 20.505 8.356 16.86 9.4 15.807l1.85 1.835v-4.608q0-.873-.621-1.495a2.04 2.04 0 0 0-1.494-.62H3.423q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V3.495h1.5v5.616a.3.3 0 0 0 .087.22.3.3 0 0 0 .221.087h5.712q.89 0 1.636.392.746.39 1.229 1.054a3.52 3.52 0 0 1 2.865-1.446h5.712a.3.3 0 0 0 .221-.086.3.3 0 0 0 .087-.221V3.495h1.5v5.616q0 .747-.53 1.277t-1.278.53h-5.712q-.873 0-1.494.622a2.04 2.04 0 0 0-.621 1.494v4.598l1.835-1.825 1.06 1.053z"
  })));
};
export default SvgMerge;